
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
// Authentication layout components
import React, { useState} from "react";
import {
    Dialog,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import * as yup from "yup";
import YupPassword from 'yup-password';
YupPassword(yup);
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import PaperComponent from "../../../components/MuiDraggableDialog";
import UserPasswordChange from "./UserPasswordChange";
import Icon from "@mui/material/Icon";
import {checkPermission, PERMISSION_DICT} from "../../../utils/Users_Roles_Permission";
import {useTranslation} from "react-i18next";

function PasswordSetting() {
    const [linkStyle,setLinkStyle] = useState({color:"#3F50B5" })
    const [openPasswordChange,setOpenPasswordChange] = React.useState(false);
    const {t} = useTranslation();

    return (
        <React.Fragment>
            <MDBox  style={{
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: 'column',
                alignItems: 'normal',
                marginBottom: '20px',
                flexWrap: 'wrap',
            }}>
                <MDTypography variant="h6" fontWeight="medium">
                    {t("AccountPage.Security")}
                </MDTypography>
                <MDTypography fontSize="14px">
                    {t("AccountPage.Keep your Darwynn account secure")}
                </MDTypography>
            </MDBox>
            {
                checkPermission(PERMISSION_DICT.AccountPasswordModify) &&
                <MDBox style={{ marginTop:"40px" }}>
                    <Grid container>
                        <Grid item xs={1.5} sx={{minWidth:"100px"}}>
                            <MDTypography style={{fontWeight:"bold",display: 'flex', fontSize:"14px", marginBottom:"20px",marginTop:"20px",paddingLeft:"20px" }}>
                                {t("AccountPage.Password")}
                            </MDTypography>
                        </Grid>
                        <Grid item xs={10.5} >
                            <div style={{maxWidth: "700px",display: 'flex', flexDirection: "column", fontSize:"14px", marginBottom:"20px",marginTop:"20px" }}>
                                <div style={{display: 'flex'}}>
                                    <div style={linkStyle}
                                         onMouseOver={() => {
                                             setLinkStyle({
                                                 color: "#3F50B5",
                                                 cursor: "pointer",
                                                 textDecorationLine: "underline"
                                             })
                                         }}
                                         onMouseLeave={() => {
                                             setLinkStyle({color: "#3F50B5"})
                                         }}
                                         onClick={() => {
                                             setOpenPasswordChange(true)
                                         }}
                                    >
                                        {t("AccountPage.Change password.")}
                                    </div>
                                    <div style={{fontSize:"16px"}}>
                                        <Icon>edit</Icon>
                                    </div>

                                </div>
                                <div>
                                    {t("AccountPage.Improve your security with a strong password.")}
                                </div>

                            </div>
                        </Grid>
                        {/*<Grid item xs={1.5} sx={{minWidth:"100px"}}>*/}
                        {/*    <MDBox style={{fontWeight: "bold", display: 'flex', fontSize: "14px",flexWrap: "wrap", marginBottom:"20px",marginTop:"20px"  ,paddingLeft:"20px"}}>*/}
                        {/*        <MDTypography style={{fontWeight:"bold",fontSize: "14px"}}>*/}
                        {/*            Two-Factor*/}
                        {/*        </MDTypography>*/}
                        {/*        <MDTypography style={{fontWeight:"bold",fontSize: "14px"}}>*/}
                        {/*            Authentication*/}
                        {/*        </MDTypography>*/}
                        {/*    </MDBox>*/}
                        {/*</Grid>*/}
                        {/*<Grid item xs={10.5}>*/}
                        {/*    <MDBox style={{display: 'flex',flexDirection: "column", fontSize:"14px" , marginBottom:"20px",marginTop:"20px" }}>*/}
                        {/*        <MDBox>*/}
                        {/*            <Tooltip title={'COMING SOON'}>*/}
                        {/*                <MDButton variant="gradient" color="info" size="small" disabled*/}
                        {/*                >coming soon... </MDButton>*/}
                        {/*            </Tooltip>*/}
                        {/*        </MDBox>*/}
                        {/*        <MDTypography style={{maxWidth: "700px", marginTop: "10px", fontSize: "14px"}}>*/}
                        {/*            Secure your Darwynn account with two-factor authentication (2FA) using both your*/}
                        {/*            password and a mobile phone code for login.*/}
                        {/*        </MDTypography>*/}
                        {/*    </MDBox>*/}
                        {/*</Grid>*/}
                    </Grid>
                </MDBox>
            }



            <Dialog
                fullWidth={true}
                maxWidth={'xs'}
                open={openPasswordChange}
                onClose={()=>{
                    setOpenPasswordChange(false)
                }}
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
            ><DialogTitle id="draggable-dialog-title" style={{ cursor: 'move' }}>
                <MDTypography variant={'h5'}>
                </MDTypography>
            </DialogTitle>
                <DialogContent >
                    <div style={{marginTop:"30px"}}>
                        <UserPasswordChange setOpen={setOpenPasswordChange}/>
                    </div>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
}

export default PasswordSetting;
